import React from 'react';
import { connect } from 'react-redux';
import { useMutation } from '@apollo/client';
import useAppSelector, { useAppDispatch } from '../app/redux/useAppSelector';
import Button from '../components/Button';
import { gql } from '../graphql/generated/gql';
import { miscToasts } from '../toasts/toasts';
import { UIActions } from '../ui/uiSlice';
import FixedBottomBanner from './FixedBottomBanner';

const RESEND_VERIFICATION_EMAIL_MUTATION = gql(/** @complexity 2 */ `
  mutation resendVerificationEmail {
    resendVerificationEmail
  }
`);

const VerifyEmailBanner = () => {
  const dispatch = useAppDispatch();
  const [resendVerificationEmail] = useMutation(
    RESEND_VERIFICATION_EMAIL_MUTATION,
  );
  const handleResend = () =>
    resendVerificationEmail().then(() =>
      dispatch(UIActions.pushToast(miscToasts.verificationEmailSent)),
    );

  return (
    <FixedBottomBanner variant="inverted">
      Some functionality such as notifications and invitations are disabled
      until you verify your email.{' '}
      <Button onClick={handleResend} variant="link">
        Resend verification
      </Button>
      .
    </FixedBottomBanner>
  );
};

VerifyEmailBanner.useIsActive = () => {
  const isVerified = useAppSelector(
    (state) => state.session.organization.isVerified,
  );

  return !isVerified;
};

export default connect()(VerifyEmailBanner);
